import { adStatuses, lineItemDerivedState, lineItemStatuses } from '../../../../../../../../../configs';

export const activeStatuses = [
  lineItemStatuses.ON.key,
  lineItemDerivedState.LIVE.key,
  lineItemDerivedState.READY.key,
  adStatuses.ON.key,
];
